import { render } from "./biddingInfo.vue?vue&type=template&id=6843897c&scoped=true"
import script from "./biddingInfo.vue?vue&type=script&lang=js"
export * from "./biddingInfo.vue?vue&type=script&lang=js"

import "./biddingInfo.vue?vue&type=style&index=0&id=6843897c&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6843897c"]])

export default __exports__